<div class="p-5 pt-1 dialog-body">
    <div mat-dialog-title>
        <h1 class="fw-bolder fs-2x"> {{ 'HOW_CAN_WE_HELP' | translate }} </h1>
        <p class="fs-4 select-ticket-text"> {{ 'SELECT_TICKET_HELP_REQUIRED_DESCRIPTION' | translate }} </p>
    </div>
    <mat-dialog-content>
        <div class="border border-dashed rounded d-flex mb-5 option-btn" (click)="closeDialog('contract')">
            <div class="col-auto mx-3 align-self-center">
                <i class="fa-duotone fa-solid fa-message-question fa-2x"></i>
            </div>
            <div class="col-10 lh-0 py-5">
                <h4>
                    {{ 'CURRENT_CONTRACT_SUPPORT' | translate }}
                </h4>
                <p>
                    {{ 'NEED_HELP_ON_CURRENT_CONTRACT' | translate }}
                </p>
            </div>
        </div>

        <div class="border border-dashed rounded d-flex option-btn" (click)="closeDialog('proposal')">
            <div class="col-auto mx-3 align-self-center">
                <i class="fa-duotone fa-solid fa-lightbulb fa-2x"></i>
            </div>
            <div class="col-10 lh-0 py-5">
                <h4>
                    {{ 'NEW_CUSTOM_PROPOSAL' | translate }}
                </h4>
                <p>
                    {{ 'NEED_OFFER_TO_FIT_NECESSITIES' | translate }}
                </p>
            </div>
        </div>
    </mat-dialog-content>
</div>